import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    skills: [
      {
        name: "HTML5",
        img: "html5",
      },
      {
        name: "CSS3",
        img: "css",
      },
      {
        name: "Sass",
        img: "sass",
      },
      {
        name: "Bootstrap",
        img: "bootstrap",
      },
      {
        name: "Tailwind Css",
        img: "tailwindcss",
      },
      {
        name: "JavaScript",
        img: "javascript",
      },
      {
        name: "Vue.js",
        img: "vuejs",
      },
      {
        name: "Vuetify",
        img: "vuetify",
      },
      {
        name: "Nuxt.js",
        img: "nuxt",
      },
      {
        name: "React.js",
        img: "react",
      },
      {
        name: "Git/Github",
        img: "github",
      },
      {
        name: "Firebase",
        img: "firebase",
      },
      {
        name: "Node.js",
        img: "nodejs",
      },
      {
        name: "Figma",
        img: "figma",
      },
    ],
    openContact: false,
    projects: [
      {
        type: "html",
        title: "Manage Landing Page",
        image: "html1",
        description:
          "This landing page was developed using HTML/CSS/JS. It is my paractice project.",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "html",
          },
          {
            name: "js",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://landing-page-frontend.netlify.app",
      },
      {
        type: "html",
        title: "Educational Website",
        image: "html2",
        description:
          "This educational website was build by me as a paractice project. I designed and developed on my own.",
        hashTags: [
          {
            name: "html",
          },
          {
            name: "css",
          },
          {
            name: "js",
          },
          {
            name: "jquery",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://sufa-academy.netlify.app",
      },
      {
        type: "html",
        title: "Portfolio",
        image: "html3",
        description:
          "This is my old portfolio website I developed with the help of tutorial.",
        hashTags: [
          {
            name: "html",
          },
          {
            name: "css",
          },
          {
            name: "js",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk/Portfolio",
        liveWebsitelink: "https://me-malik.netlify.app",
      },
      {
        type: "html",
        title: "Dog Boarding Landing Page",
        image: "html4",
        description:
          "I developed this project during my Internship at Rigrex. This project cleared my confusions related to Sass and JS.",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "html",
          },
          {
            name: "js",
          },
          {
            name: "sass",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://dog-boarding.netlify.app",
      },
      {
        type: "js",
        title: "Todo App",
        image: "js1",
        description:
          "Todo App allow us to add a todo , remove a todo and also we can filter todos by name.",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "html",
          },
          {
            name: "js",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://todos-app-js.netlify.app",
      },
      {
        type: "js",
        title: "Notes App",
        image: "js2",
        description:
          "Save your important notes by using Notes App. This application allow to save notes, delete notes and updates notes",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "html",
          },
          {
            name: "js",
          },
          {
            name: "firebase",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://js-notes-appp.netlify.app",
      },
      {
        type: "vue",
        title: "Weather App",
        image: "js3",
        description:
          "Want update about daily weather? Use Weather application it displays correct weather info. I devloped it using Api.",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "vue",
          },
          {
            name: "api",
          },

        ],
        githublink: "https://github.com/Shahab-Malikk/Vue-Weather-App",
        liveWebsitelink: "https://weather-appp-js.netlify.app",
      },
      {
        type: "vue",
        title: "Blogging Website Vue",
        image: "vue1",
        description:
          "This was my final project during Internship at rigrex. It is a single page application and it covers almost all features of Vue.js",
        hashTags: [
          {
            name: "css",
          },
          {
            name: "vue.js",
          },
        
        ],
        githublink: "https://github.com/Shahab-Malikk/WOW-Blogs",
        liveWebsitelink: "https://wowblogs.netlify.app",
      },
      {
        type: "vue",
        title: "POS Vuetify",
        image: "vue2",
        description:
          "POS Vuetify is a single page webapplication. I developed it's frontend using Vue.js and Vuetify",
        hashTags: [
          {
            name: "vue.js",
          },
          {
            name: "vuetify",
          },
          {
            name: "css",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://vue-pos-system.netlify.app",
      },
      {
        type: "vue",
        title: "Common People",
        image: "vue3",
        description:
          "This project was from my client on Fiverr. It's a multipage NUXT application having animations and eye catching design.",
        hashTags: [
          {
            name: "nuxt.js",
          },
          {
            name: "vue.js",
          },
          {
            name: "sass",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk",
        liveWebsitelink: "https://dev.wearecommon.xyz",
      },
      {
        type: "vue",
        title: "Word Scramble Game",
        image: "vue4",
        description:
          "It's another project from a Fiverr's client. Word scramble game is a simple game in which you have to guess the word.",
        hashTags: [
          {
            name: "vue.js",
          },
          {
            name: "css",
          },
          
        ],
        githublink: "https://github.com/Shahab-Malikk/Word-Scramble-Game-Vue.js",
        liveWebsitelink: "https://word-scramble-v2.netlify.app",
      },
      {
        type: "js",
        title: "COVID Tracking Web Application",
        image: "vue5",
        description:
          "It's a simple COVID tracking web application which tracks number of cases and deaths specified by country.",
        hashTags: [
          {
            name: "js",
          },
          {
            name: "html",
          },
          {
            name: "api",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk/Covid-Tracker-Vue",
        liveWebsitelink: "https://covid-tracker-jss.netlify.app",
      },
      {
        type: "react",
        title: "Advice Geneartor",
        image: "react1",
        description:
          "Advice Generator is a simple web application developed in React using Api. It's my first project in React.js",
        hashTags: [
          {
            name: "react",
          },
          {
            name: "css",
          },
          {
            name: "api",
          },
        ],
        githublink: "https://github.com/Shahab-Malikk/React-Advice-Generator-App",
        liveWebsitelink: "https://advice-generator-reactt.netlify.app",
      },
    ],
  },
  mutations: {
    SET_CONTACT_FORM_OPEN(state) {
      state.openContact = true;
    },
    SET_CONTACT_FORM_CLOSE(state) {
      state.openContact = false;
    },
  },
  actions: {
    openContact({ commit }) {
      commit("SET_CONTACT_FORM_OPEN");
    },
    closeContact({ commit }) {
      commit("SET_CONTACT_FORM_CLOSE");
    },
  },
  getters: {
    skills: (state) => state.skills,
    openContact: (state) => state.openContact,
    projects: (state) => state.projects,
  },
});
